function PromoPopup(sectionId) {
  const node = document.getElementById(`PromoPopupConfig-${sectionId}`);
  const config = node ? JSON.parse(node.textContent) : {};

  return {
    name: config.name,
    storageKey: config.storageKey,
    enabled: Boolean(config.enabled),
    delayMs: Number(config.delayMs) || 0,
    days: Number(config.days) || 14,
    frequency: config.frequency || 'once',
    homeOnly: Boolean(config.homeOnly),
    isHome: Boolean(config.isHome),
    promoCode: config.promoCode || '',
    copied: false,
    timer: null,
    opened: false,
    init() {
      this.$store.modals.register(this.name, 'popup');
      initTeleport(this.$root);

      document.body.addEventListener('popup-will-close', () => {
        if (this.$store.modals.popup.contents === this.name) this.remember();
      });

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:select', (e) => {
          if (!e.target.contains(this.$root) || !this.enabled) return;
          this.$store.modals.open(this.name);
        });
        document.addEventListener('shopify:section:deselect', (e) => {
          if (!e.target.contains(this.$root)) return;
          this.$store.modals.close(this.name);
        });
        return;
      }

      if (!this.shouldShow()) return;
      this.timer = setTimeout(() => {
        this.opened = true;
        this.$store.modals.open(this.name);
      }, this.delayMs);
    },
    shouldShow() {
      if (!this.enabled) return false;
      if (this.homeOnly && !this.isHome) return false;
      if (this.frequency === 'session' && sessionStorage.getItem(this.storageKey)) return false;
      if (
        this.frequency === 'once' &&
        typeof getExpiringStorageItem === 'function' &&
        getExpiringStorageItem(this.storageKey)
      ) {
        return false;
      }
      return true;
    },
    remember() {
      if ((window.Shopify && Shopify.designMode) || !this.opened) return;
      if (this.frequency === 'every_visit') return;
      if (this.frequency === 'session') sessionStorage.setItem(this.storageKey, '1');
      if (this.frequency === 'once' && typeof setExpiringStorageItem === 'function') {
        setExpiringStorageItem(this.storageKey, '1', daysInMs(this.days));
      }
    },
    dismiss() {
      this.remember();
      this.$store.modals.close(this.name);
    },
    copyCode() {
      if (!this.promoCode || !navigator.clipboard) return;
      navigator.clipboard.writeText(this.promoCode).then(() => {
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 1600);
      }).catch(() => {});
    },
  };
}

window.PromoPopup = PromoPopup;
